 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled, DicVal, RandomKey } from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import EntryLayout from '../components/EntryLayout';
import SwatchBoard from './SwatchBoard';
import SwatchExhibitionColorSizeDialog from './components/SwatchExhibitionColorSizeDialog';
import { recalculateSwatchLayout } from './SwatchLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, entrydata } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const Swatch = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", IMAGE: "pic", FILE: "file", NB: "nb", PL: "pl", ROW:"1" }
    const primarykeys = ["SWT_NO"];

    const formid = getformid("Swatch", props.location.search);
    const controller = getcontroller("Swatch", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State
    const CELLTYPE = CellType();

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [rowmode, setrowmode] = useState(0);      //0:品番明細 1:スワッチ
    const [swatchAddPositionOpen, setSwatchAddPositionOpen] = useState(false);
    const [swatchExhibitionDetail, setSwatchExhibitionDetail] = useState(null);
　   const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  
    const swatchItemKeysRef = useRef(new WeakMap());
    const swatchItemKeySeedRef = useRef(0);
    const swatchPendingScrollTopRef = useRef(null);
    const swatchShowImageSetterRef = useRef(null);
    const swatchItemsSetterRef = useRef(null);
    const swatchGataSuSetterRef = useRef(null);
    const swatchSelectedItemKeyRef = useRef(null);
    const swatchAddTargetItemKeyRef = useRef(null);

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
   function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    const actionurl = {
        "getlist": "Swatch/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "print1", icon: "print", label: "スワッチ作成帳票出力" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };

    //主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    //項目名取得
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    dispatch(listoption(data.listoption));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({id:panel.id, type:panel.type, index:idx});
                        idx++;
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    useEffect(() => {
        changecelllock(["KUBUN", "SWT_GATASU"], formstatus === "ENTRY FORM");
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            //展示会の場合展示会No有効
            changecelllock(["SWT_TNJNO"], entrydataRef.current["KUBUN"] === "0");
            rerender();
        }
    }, [formstatus]);

    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
       //データ読み込み
        LoadData(code);
        return true;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (action === "print1") {      //スワッチ発行
            let url = entrydataRef.current["SWT_GATASU"] === "6" ? "Swatch6Report/Generate" : "Swatch8Report/Generate";
            fnc.current.postaxios(url, { controller: controller, id: action, swtNo: edittingcode },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
   }
    function Save(finallycallback, nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        SetPLData();    //PL行データをentrydataRefにセット
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData(gridlist[i].id);
        }
        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }
        storeRowData();
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "Swatch/UpdateEntry" : "Swatch/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if(pkey !== "")  entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("forms", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください","　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("Swatch/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
               },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('Swatch/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            // API 側で detail / files / images が未返却でも画面を落とさない
                            const detailData = isEmpty(data.detail) ? {} : data.detail;
                            for (let i = 0; i < gridlist.length; i++) {
                                const detailRows = detailData[gridlist[i].type];
                                if (Array.isArray(detailRows) ? detailRows.length !== 0 : !isEmpty(detailRows)) {
                                    SetGridData({ id: gridlist[i].id, type: gridlist[i].type }, detailRows);
                                }
                            }

                            dispatch(setimagelist(imageRef.current));
                            rerender();
                        }
                        fnc.current.wait(false);
                   } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                   }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    //入力フィールドクリア
    function clearform(newform) {
        setrowmode(0);
        entrydataRef.current = null;
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            var initdata = initializedata(textfieldsall, staff);
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall, data: initdata },
            {
                onSuccess: function (data) {
                    entrydataRef.current = data.data;
                    rerender();
                    fnc.current.wait(false);
                },
            }, 'wait'
            )
        }
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({id:gridlist[i].id, type:gridlist[i].type}));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id })); 
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
               },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        if (id === "SWT_TNJNO") {
            if (isEmpty(value)) {
                const newData = { ...entrydataRef.current };
                newData["SWT_YEAR"] = "";
                newData["SWT_SEASONCD"] = "";
                newData["SWT_SEASONCD_nm"] = "";
                newData["TNJ_OPENDATE"] = "";
                entrydataRef.current = newData;
                fnc.current.entryrerender();
            }
        }
        if (id === "KUBUN") {
            //展示会の場合展示会No有効
            changecelllock(["SWT_TNJNO"], value === "0");
            if (value === "0") {    //通常の場合
                const newData = { ...entrydataRef.current };
                newData["SWT_TNJNO"] = "";
                newData["SWT_YEAR"] = "";
                newData["SWT_SEASONCD"] = "";
                newData["SWT_SEASONCD_nm"] = "";
                newData["TNJ_OPENDATE"] = "";
                entrydataRef.current = newData;
            }
        }
        if (id === "SWT_GATASU") {
            const rowPanel = gridlist.find(item => item.id === G_id.ROW);
            if (!isEmpty(rowPanel)) {
                const details = GridData(rowPanel);
                if (Array.isArray(details)) {
                    const recalculatedDetails = recalculateSwatchLayout(details, Number(value));
                    SetGridData(rowPanel, recalculatedDetails);
                    if (swatchGataSuSetterRef.current) {
                        swatchGataSuSetterRef.current(Number(value));
                    }
                    if (rowmode === 0) {
                        const gridApi = GridApi(rowPanel);
                        if (!isEmpty(gridApi)) gridApi.setGridOption('rowData', recalculatedDetails);
                    }
                    if (rowmode === 1 && swatchItemsSetterRef.current) {
                        swatchItemsSetterRef.current(swatchBoardItems(recalculatedDetails));
                    }
                    fnc.current.modify(true);
                }
            }
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    //編集ロック
    function changecelllock(columnids, locked) {
        const updateColumns = (fields) => {
            if (isEmpty(fields) || !Array.isArray(columnids)) return fields;

            let changed = false;
            const newfields = DeepCopy(fields);

            newfields.forEach(field => {
                if (columnids.includes(field.columnid) && field.locked !== locked) {
                    field.locked = locked;
                    changed = true;
                }
            });

            return changed ? newfields : fields;
        };

        settextfields(prev => updateColumns(prev));
    }

    //品番追加
    function additem() {
        if (entrylock) return;
        const rowPanel = gridlist.find(item => item.id === G_id.ROW);
        if (isEmpty(rowPanel)) return;
        const gridApi = GridApi(rowPanel);
        if (isEmpty(gridApi)) return;

        const selectedNodes = gridApi.getSelectedNodes();
        if (selectedNodes.length > 1) {
            fnc.current.warnmsg('複数行選択中は品番追加できません。1行のみ選択してください。');
            return;
        }
        if (selectedNodes.length === 0) {
            openSwatchItemSearch('append');
            return;
        }
        openSwatchItemSearch('before', selectedNodes[0].data);
    }

    function openSwatchItemSearch(insertMode, targetDetail) {
        if (isEmpty(DicVal(entrydataRef.current, 'SWT_BRDCD'))) {
            swatchAddTargetItemKeyRef.current = null;
            fnc.current.warnmsg('ブランドが指定されていません');
            return;
        }
        fnc.current.searchlistopen({
            label: "スワッチ品番検索",
            multiple: true,
            rowmode: false,
            data: { dataid: 'V_PDT_SWATCH', datatype: CELLTYPE.MASTERCODE, initial: true },
            rowdata: entrydataRef.current,
            rowid: null,
            currowid: null,
            doApply: e => ApplySwatchItems(e, insertMode, targetDetail),
        });
    }

    function addSwatchItem() {
        if (entrylock) return;
        if (isEmpty(swatchSelectedItemKeyRef.current)) {
            swatchAddTargetItemKeyRef.current = null;
            openSwatchItemSearch('append');
            return;
        }
        swatchAddTargetItemKeyRef.current = swatchSelectedItemKeyRef.current;
        setSwatchAddPositionOpen(true);
    }

    function selectSwatchAddPosition(insertMode) {
        setSwatchAddPositionOpen(false);
        openSwatchItemSearch(insertMode);
    }

    function cancelSwatchAddPosition() {
        swatchAddTargetItemKeyRef.current = null;
        setSwatchAddPositionOpen(false);
    }

    function ApplySwatchItems(e, insertMode, targetDetail) {
        const targetItemKey = swatchAddTargetItemKeyRef.current;
        swatchAddTargetItemKeyRef.current = null;
        fnc.current.searchlistclose();
        const selectedRows = Array.isArray(e.items) ? e.items.map(item => item.data || item) : [];
        if (selectedRows.length === 0) return;

        const rowPanel = gridlist.find(item => item.id === G_id.ROW);
        if (isEmpty(rowPanel)) return;
        const currentDetails = GridData(rowPanel);
        if (!Array.isArray(currentDetails)) return;

        let additionalRows = selectedRows;
        if (DicVal(entrydataRef.current, 'KUBUN') !== '0') {
            const existingCodes = new Set(currentDetails.map(detail => String(DicVal(detail, 'SWT_OPPICD'))));
            const acceptedCodes = new Set();
            const duplicateCodes = [];
            additionalRows = selectedRows.filter(row => {
                const code = String(DicVal(row, 'PDT_OPPICD'));
                if (existingCodes.has(code) || acceptedCodes.has(code)) {
                    if (!duplicateCodes.includes(code)) duplicateCodes.push(code);
                    return false;
                }
                acceptedCodes.add(code);
                return true;
            });
            if (duplicateCodes.length !== 0) {
                fnc.current.warnmsg(['以下の品番は既に存在している為、追加されませんでした。', ...duplicateCodes]);
            }
        }
        if (additionalRows.length === 0) return;

        fnc.current.postaxios('Swatch/GetAdditionalItems', {
            data: entrydataRef.current,
            colinfo: columninfo,
            rowdata: additionalRows
        }, {
            onSuccess: function (data) {
                const resolvedRows = Array.isArray(data.rowdata)
                    ? data.rowdata.map(row => ({ ...row, rowid: RandomKey() }))
                    : [];
                if (resolvedRows.length === 0) {
                    fnc.current.wait(false);
                    return;
                }

                const latestDetails = GridData(rowPanel);
                const nextDetails = Array.isArray(latestDetails)
                    ? latestDetails.filter(detail => isSwatchDetail(detail))
                    : [];
                let insertIndex = nextDetails.length;
                if (insertMode === 'before') {
                    if (!isEmpty(targetDetail)) {
                        const targetIndex = nextDetails.indexOf(targetDetail);
                        if (targetIndex !== -1) insertIndex = targetIndex;
                    } else if (!isEmpty(targetItemKey)) {
                        const selectedItem = swatchBoardItems(nextDetails)
                            .find(item => item.itemKey === targetItemKey);
                        if (!isEmpty(selectedItem)) insertIndex = nextDetails.indexOf(selectedItem.detail);
                    }
                }
                nextDetails.splice(insertIndex, 0, ...resolvedRows);

                const gataSu = Number(DicVal(entrydataRef.current, 'SWT_GATASU'));
                const recalculatedDetails = recalculateSwatchLayout(nextDetails, gataSu);
                if (rowmode === 0) {
                    const gridApi = GridApi(rowPanel);
                    if (!isEmpty(gridApi)) gridApi.setGridOption('rowData', recalculatedDetails);
                }
                SetGridData(rowPanel, recalculatedDetails);
                if (swatchItemsSetterRef.current) {
                    swatchItemsSetterRef.current(swatchBoardItems(recalculatedDetails));
                }
                fnc.current.modify(true);
                fnc.current.wait(false);
            },
            errmsg: '品番の追加に失敗しました'
        });
    }
    //品番削除
    function deleteitem() {
        if (entrylock) return;
        const rowPanel = gridlist.find(item => item.id === G_id.ROW);
        if (isEmpty(rowPanel)) return;
        const gridApi = GridApi(rowPanel);
        if (isEmpty(gridApi)) return;

        const selectedNodes = gridApi.getSelectedNodes();
        if (selectedNodes.length === 0) {
            fnc.current.warnmsg('行を選択してください');
            return;
        }

        const selectedNodeSet = new Set(selectedNodes);
        const remainingDetails = [];
        gridApi.forEachNode(node => {
            if (!selectedNodeSet.has(node)) remainingDetails.push(node.data);
        });

        const gataSu = Number(DicVal(entrydataRef.current, 'SWT_GATASU'));
        const recalculatedDetails = recalculateSwatchLayout(remainingDetails, gataSu);
        gridApi.setGridOption('rowData', recalculatedDetails);
        SetGridData(rowPanel, recalculatedDetails);
        if (swatchItemsSetterRef.current) {
            swatchItemsSetterRef.current(swatchBoardItems(recalculatedDetails));
        }
        fnc.current.modify(true);
    }

    function rowmodeChange() {
        swatchSelectedItemKeyRef.current = null;
        swatchAddTargetItemKeyRef.current = null;
        if (rowmode === 0) {    //品番明細→スワッチ
            const rowPanel = gridlist.find(e => e.id === G_id.ROW);
            if (!isEmpty(rowPanel)) storeRowData(rowPanel);
            setrowmode(1);
        } else {                //スワッチ→品番明細
            setrowmode(0);
        }
    }

    function isSwatchDetail(detail) {
        if (isEmpty(detail)) return false;
        if (detail.SWT_OPPICD === null || detail.SWT_OPPICD === undefined) return false;
        return String(detail.SWT_OPPICD).trim() !== '';
    }

    function swatchItemKey(detail) {
        if (!isEmpty(detail.rowid)) return `row-${detail.rowid}`;
        if (!swatchItemKeysRef.current.has(detail)) {
            swatchItemKeySeedRef.current += 1;
            swatchItemKeysRef.current.set(detail, `swatch-${swatchItemKeySeedRef.current}`);
        }
        return swatchItemKeysRef.current.get(detail);
    }

    function swatchBoardItems(details) {
        if (!Array.isArray(details)) return [];
        return details.filter(isSwatchDetail).map(detail => ({
            detail: detail,
            itemKey: swatchItemKey(detail)
        }));
    }

    function onSwatchRowReorder(panel, param) {
        const reorderedDetails = GridData(panel);
        if (!Array.isArray(reorderedDetails)) return;

        const reorderedItems = swatchBoardItems(reorderedDetails);
        const gataSu = Number(DicVal(entrydataRef.current, 'SWT_GATASU'));
        const recalculatedDetails = recalculateSwatchLayout(reorderedDetails, gataSu);

        let swatchIndex = 0;
        recalculatedDetails.forEach(detail => {
            if (!isSwatchDetail(detail)) return;
            const sourceItem = reorderedItems[swatchIndex];
            swatchIndex += 1;
            if (!isEmpty(sourceItem) && isEmpty(detail.rowid)) {
                swatchItemKeysRef.current.set(detail, sourceItem.itemKey);
            }
        });

        if (!isEmpty(param) && !isEmpty(param.api)) {
            let rowIndex = 0;
            param.api.forEachNode(node => {
                node.setData(recalculatedDetails[rowIndex]);
                rowIndex += 1;
            });
        }
        SetGridData(panel, recalculatedDetails);
        fnc.current.modify(true);
    }

    function onSwatchDelete(panel, itemKey) {
        if (entrylock) return;
        const details = GridData(panel);
        if (!Array.isArray(details)) return;

        const currentItems = swatchBoardItems(details);
        const targetItem = currentItems.find(item => item.itemKey === itemKey);
        if (isEmpty(targetItem)) return;
        const targetIndex = details.indexOf(targetItem.detail);
        if (targetIndex === -1) return;

        const remainingDetails = details.filter((detail, index) => index !== targetIndex);
        const remainingItems = currentItems.filter(item => item.itemKey !== itemKey);
        const gataSu = Number(DicVal(entrydataRef.current, 'SWT_GATASU'));
        const recalculatedDetails = recalculateSwatchLayout(remainingDetails, gataSu);

        let swatchIndex = 0;
        recalculatedDetails.forEach(detail => {
            if (!isSwatchDetail(detail)) return;
            const sourceItem = remainingItems[swatchIndex];
            swatchIndex += 1;
            if (!isEmpty(sourceItem) && isEmpty(detail.rowid)) {
                swatchItemKeysRef.current.set(detail, sourceItem.itemKey);
            }
        });

        SetGridData(panel, recalculatedDetails);
        if (swatchItemsSetterRef.current) {
            swatchItemsSetterRef.current(swatchBoardItems(recalculatedDetails));
        }
        fnc.current.modify(true);
    }

    function openSwatchExhibitionColorSize(detail) {
        if (formstatus !== 'ENTRY FORM') return;
        if (String(DicVal(entrydataRef.current, 'KUBUN')).trim() !== '1') return;

        const exhibitionNo = String(DicVal(entrydataRef.current, 'SWT_TNJNO') || '').trim();
        const ownerCode = String(DicVal(entrydataRef.current, 'SWT_SYOYU') || '').trim();
        const brandCode = String(DicVal(entrydataRef.current, 'SWT_BRDCD') || '').trim();
        const oppiCode = String(DicVal(detail, 'SWT_OPPICD') || '').trim();
        if (exhibitionNo === '' || ownerCode === '' || brandCode === '' || oppiCode === '') return;

        setSwatchExhibitionDetail(detail);
    }

    function closeSwatchExhibitionColorSize() {
        setSwatchExhibitionDetail(null);
    }

    function onSwatchReorder(panel, orderedItemKeys) {
        if (!Array.isArray(orderedItemKeys)) return;
        const details = GridData(panel);
        if (!Array.isArray(details)) return;

        const currentItems = swatchBoardItems(details);
        const currentKeys = currentItems.map(item => item.itemKey);
        if (currentKeys.length !== orderedItemKeys.length) return;
        if (currentKeys.every((key, index) => key === orderedItemKeys[index])) return;

        const itemByKey = new Map(currentItems.map(item => [item.itemKey, item]));
        const reorderedItems = orderedItemKeys.map(itemKey => itemByKey.get(itemKey));
        if (reorderedItems.some(item => isEmpty(item))) return;
        if (new Set(orderedItemKeys).size !== currentItems.length) return;

        let swatchIndex = 0;
        const reorderedDetails = details.map(detail => {
            if (!isSwatchDetail(detail)) return detail;
            const reorderedDetail = reorderedItems[swatchIndex].detail;
            swatchIndex += 1;
            return reorderedDetail;
        });
        const gataSu = Number(DicVal(entrydataRef.current, 'SWT_GATASU'));
        const recalculatedDetails = recalculateSwatchLayout(reorderedDetails, gataSu);

        swatchIndex = 0;
        recalculatedDetails.forEach(detail => {
            if (!isSwatchDetail(detail)) return;
            const sourceItem = reorderedItems[swatchIndex];
            swatchIndex += 1;
            if (isEmpty(detail.rowid)) {
                swatchItemKeysRef.current.set(detail, sourceItem.itemKey);
            }
        });

        SetGridData(panel, recalculatedDetails);
        fnc.current.modify(true);
        return swatchBoardItems(recalculatedDetails);
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            if (props.panel.id === G_id.ROW) {
                if (rowmode === 0) {
                    return (
                        <EntryGridAr
                            id={fnc.current.GridID(props.panel)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                            columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            ValueChanged={() => storeRowData(props.panel)}
                            SwapRow={e => onSwatchRowReorder(props.panel, e)}
                            CellDoubleClicked={e => openSwatchExhibitionColorSize(e.data)}
                            panel={props.panel}
                            rowContext={1}
                            fillAvailableHeight={true}
                        />
                    );
                }
                const details = GridData(props.panel);
                return (
                    <SwatchBoard
                        items={swatchBoardItems(details)}
                        gataSu={DicVal(entrydataRef.current, 'SWT_GATASU')}
                        disabled={entrylock}
                        showImageSetterRef={swatchShowImageSetterRef}
                        itemsSetterRef={swatchItemsSetterRef}
                        gataSuSetterRef={swatchGataSuSetterRef}
                        pendingScrollTopRef={swatchPendingScrollTopRef}
                        onSelectionChange={itemKey => { swatchSelectedItemKeyRef.current = itemKey; }}
                        onDelete={itemKey => onSwatchDelete(props.panel, itemKey)}
                        onReorder={orderedItemKeys => onSwatchReorder(props.panel, orderedItemKeys)}
                        onImageDoubleClick={openSwatchExhibitionColorSize}
                    />
                );
            }
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{
                padding: '5px 15px',
                paddingBottom: 0,
                height: '100%',
                overflow: 'hidden',
                backgroundColor: '#D8D8D8',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0
            }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems={p.id === '1' ? "stretch" : "center"}
                           padding="5px"
                           style={{ flex: p.id === '1' ? '1 1 auto' : '0 0 auto', minHeight: p.id === '1' ? 0 : undefined }}
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10,
                                    display: p.id === '1' ? 'flex' : undefined,
                                    flexDirection: p.id === '1' ? 'column' : undefined,
                                    minHeight: p.id === '1' ? 0 : undefined
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5, minHeight: p.id === '1' && rowmode === 1 ? 32 : undefined, flex: p.id === '1' ? '0 0 auto' : undefined }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {p.id === '1' && rowmode === 0 ? 
                                       <div style={{ position: 'absolute', left: 100, top: -3 }}>
                                           <Button size="small" onClick={additem}
                                               style={{
                                                   width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 750, marginRight: 20
                                               }}
                                           >
                                               品番追加
                                           </Button>
                                           <Button size="small" onClick={deleteitem}
                                               style={{
                                                   width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 20
                                               }}
                                           >
                                               明細行削除
                                           </Button>
                                       </div>
                                       :null
                                   }

                                   {p.id === '1' && rowmode === 1 ?
                                       <div style={{ position: 'absolute', left: 100, top: -8, display: 'flex', alignItems: 'center' }}>
                                           <Button
                                               size="small"
                                               disabled={entrylock}
                                               onClick={addSwatchItem}
                                               style={{
                                                   width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 750, marginRight: 20
                                               }}
                                           >
                                               品番追加
                                           </Button>
                                           <FormControlLabel
                                               control={
                                                   <Checkbox
                                                       defaultChecked
                                                       onChange={event => {
                                                           if (swatchShowImageSetterRef.current) swatchShowImageSetterRef.current(event.target.checked);
                                                       }}
                                                       color="default"
                                                       size="small"
                                                       style={{ padding: 4 }}
                                                   />
                                               }
                                               label="絵型を表示する"
                                           />
                                       </div>
                                       : null
                                   }

                                   {p.id === '1' ?
                                       <div style={{ position: 'absolute', right: 100, top: -3 }}>
                                           <Button size="small" endIcon={<Icon style={{ fontSize: 16 }}>arrow_forward</Icon>} onClick={rowmodeChange}>
                                               {rowmode === 0 ? "スワッチ" : "品番明細"}
                                           </Button>
                                       </div>
                                       : null
                                   }
                                   {layoutlock || sectionclose ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                </div>
                                {p.id === '1' ?
                                    <div style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                                        <Contents panel={p}/>
                                    </div>
                                    : <Contents panel={p}/>
                                }
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                lockcell={ListlockCell}
                suppressaction={suppressaction}
                usecondition={true}
           >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            <SwatchExhibitionColorSizeDialog
                open={swatchExhibitionDetail !== null}
                detail={swatchExhibitionDetail}
                exhibitionNo={DicVal(entrydataRef.current, 'SWT_TNJNO')}
                ownerCode={DicVal(entrydataRef.current, 'SWT_SYOYU')}
                brandCode={DicVal(entrydataRef.current, 'SWT_BRDCD')}
                oppiCode={DicVal(swatchExhibitionDetail, 'SWT_OPPICD')}
                editable={formstatus === 'ENTRY FORM' && !entrylock}
                fnc={fnc}
                onClose={closeSwatchExhibitionColorSize}
            />
            <Dialog
                open={swatchAddPositionOpen}
                onClose={cancelSwatchAddPosition}
                disableBackdropClick={true}
                aria-labelledby="swatch-add-position-dialog-title"
            >
                <DialogTitle id="swatch-add-position-dialog-title">品番の追加位置</DialogTitle>
                <DialogContent>品番の追加位置を選択してください。</DialogContent>
                <DialogActions>
                    <Button onClick={() => selectSwatchAddPosition('before')} color="primary">
                        選択位置へ挿入
                    </Button>
                    <Button onClick={() => selectSwatchAddPosition('append')} color="primary">
                        末尾へ追加
                    </Button>
                    <Button onClick={cancelSwatchAddPosition} color="primary">
                        キャンセル
                    </Button>
                </DialogActions>
            </Dialog>
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                        }}
                        component="ul"
                        elevation={0}
                        style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};

